import styled from "styled-components";

export const ControllerParticipationWrapper = styled.div<{
  isSearch: boolean;
  isWide: boolean;
}>`
  width: ${({ isSearch, isWide }) =>
    isWide ? (isSearch ? "514px" : "440px") : "calc(100% - 32px)"};
  height: ${({ isSearch }) => (isSearch ? "446px" : "366px")};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 40px 15px 0;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  position: absolute;
  z-index: 100;

  > .title {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    color: #121212;
    margin-bottom: 12px;
  }
`;

export const ControllerParticipationContent = styled.div``;

export const ControllerParticipationUserWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ControllerParticipantUserNameWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;

  > .name {
    background: #7f25fb;
    width: max-content;
    height: 35px;
    border-radius: 10px;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 12px;
    line-height: 35px;
    text-align: center;
    color: #fff;
    padding: 0 25px;
    box-sizing: border-box;
  }

  > .more {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    > img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    > .memo {
      position: absolute;
      width: max-content;
      height: auto;
      padding: 8px 10px;
      border-radius: 10px;
      background: #ffffff;
      border: 0.93px solid #d9d9d9;
      box-shadow: 0px 3.71px 3.71px 0px #00000040;
      box-sizing: border-box;
      top: 120%;
      left: 0;
      z-index: 100;
      font-family: Pretendard;
      font-weight: 500;
      font-size: 15px;
      min-width: 150px;
      text-align: left;
    }
  }
`;

export const ControllerParticipationUserPoint = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  > .point {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: Pretendard;
    line-height: 100%;
    color: #121212;
    gap: 4px;

    > .name {
      font-size: 12px;
      font-weight: 500;
    }

    > .value {
      font-size: 13px;
      font-weight: 600;
    }
  }
`;

export const ControllerMemberSearchWrapper = styled.div`
  width: 100%;
`;

export const ControllerMemberSearchListWrapper = styled.div`
  background: #e5e5e5;
  margin-top: 5px;
  width: calc(100% - 30px);
  height: 128px;
  overflow: auto;
  scrollbar-width: none;
  border-radius: 15px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-x: hidden;
`;

export const ControllerMemberSearchListItem = styled.div<{ isWide: boolean }>`
  width: calc(100% - 30px);
  height: ${({ isWide }) => (isWide ? "37px" : "28px")};
  flex-shrink: 0;
  border-radius: 14.71px;
  padding: 5px 16px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 14.67px;
  line-height: 100%;
  text-align: center;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  > div {
    display: flex;
    gap: 5px;
  }

  span {
    color: rgb(139, 139, 139);
  }

  .warning {
    color: #f00;
  }
`;
